/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Oscoachmail2Inputs */

const de__field_oscoachmail2 = /** @type {(inputs: _Field_Oscoachmail2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail OS-Coach`)
};

/**

* @param {_Field_Oscoachmail2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_oscoachmail2 = /** @type {((inputs?: _Field_Oscoachmail2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Oscoachmail2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_oscoachmail2(inputs)
});
export { _field_oscoachmail2 as "_field_osCoachMail" }